import { render } from "./IconDownload.vue?vue&type=template&id=59fb9388"
const script = {}

import exportComponent from "/Users/david/Documents/GitHub/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"IconDownload.vue"]])

export default __exports__